import React, { Component } from "react";
import Body from "../item/body";
import Image from "../item/image";
import { merge, $ } from "glamor";
import Banner from "../item/banner";
import ColorBanner from "../item/color-banner";
import Palette from "components/icons/palette";
import theme from "styles/theme";
import { ItemCellSize } from "constants/types";
import ViewBase from "./base";
import VariantsProvider from "components/variants-provider";

const ITEM_HEIGHT = 232;
const ITEM_WIDTH = 102;
const SHADOW = 5;

const CONTAINER_HEIGHT = ITEM_HEIGHT + SHADOW * 2;
const CONTAINER_WIDTH = ITEM_WIDTH + SHADOW * 2;

class ItemTileView extends Component {
    static height = CONTAINER_HEIGHT;
    static width = CONTAINER_WIDTH;
    static horizontalOffset = 16 - SHADOW * 2;
    static verticalOffset = 16 - SHADOW * 2;

    static styles = merge(
        {
            width: `${CONTAINER_WIDTH}px`,
            height: `${CONTAINER_HEIGHT}px`,
        },
        $(" .item", {
            height: `${ITEM_HEIGHT}px`,
            width: `${ITEM_WIDTH}px`,
            padding: "4px",
        }),
        $(" .imageHolder", {
            position: "relative",
            overflow: "hidden",
            height: "152px",
            width: "100%",
            flexShrink: 0,
            flexGrow: 0,
            display: "flex",
            alignItems: "center",
        }),
        $(" .unavailableProduct", {
            position: "absolute",
            width: `${ITEM_WIDTH - 8}px`,
            backgroundColor: theme.palette.errorBackgroundColor,
            color: theme.palette.errorColor,
            height: "150px",
            top: "20%",
            padding: "8px",
            fontSize: "12px",
            left: "4px",
        }),
        $(" .unavailable", {
            opacity: "0.3",
        })
    );

    render() {
        const { item, view, scope, catalogEntry, viewport, isTile = true } = this.props;
        const { hover, inOrder, inActiveList } = this.state;
        const swapOnHover = scope.brand.hasPreference("swap_product_image_on_hover");
        return (
            <article>
                {this.renderBulkSelector()}
                {viewport !== "mobile" && this.productActionMenu()}
                <div className={`imageHolder ${item && item.__out_of_range ? "unavailable" : ""}`}>
                    <Image swapOnHover={swapOnHover} item={item} scope={scope} size={"T"} />
                    <ColorBanner item={item} hover={hover} inOrder={inOrder} inActiveList={inActiveList} />
                    <Banner item={item} small={true} scope={scope} />
                    {item && item.hasCustomizationBanner(scope) && (
                        <Banner item={item} small={true} banner={item.getCustomizationBanner(scope)} scope={scope} />
                    )}
                    {this.renderActions(2, isTile)}
                </div>
                <div className={`content ${item && item.__out_of_range ? "unavailable" : ""}`}>
                    <Body
                        item={item}
                        shipStart={this.getShipStart()}
                        view={view}
                        small={true}
                        lines={1}
                        showPrice={true}
                        hideMSRP={true}
                        size={ItemCellSize.Tile}
                        scope={scope}
                    />
                </div>
                <VariantsProvider item={item}>
                    {() => (
                        <Palette
                            style={{
                                color: theme.palette.grey,
                                position: "absolute",
                                bottom: "4px",
                                right: "4px",
                                height: "14px",
                                width: "14px",
                            }}
                        />
                    )}
                </VariantsProvider>
                {item && item.__out_of_range && catalogEntry && (
                    <div className="unavailableProduct">{catalogEntry.unavailableProductWarning(scope)}</div>
                )}
            </article>
        );
    }
}

export default ViewBase(ItemTileView);
